import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_repo_list = _resolveComponent("repo-list")!

  return (_openBlock(), _createBlock(_component_repo_list, {
    repos: _ctx.sortedRepos,
    reposToPulls: _ctx.reposToPulls,
    header: "Contributions"
  }, null, 8, ["repos", "reposToPulls"]))
}